import React, { useEffect, FC, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { message, Pagination, Select, Input, Button, Breadcrumb } from "antd";

import "./subjectNavigation.less";
import axios from "@/axios/axios";
import * as actions from "@/store/actions";
const keyWordMap = new Map([
  [11, "itemName"],
  [12, "itemLeaderName"],
  [13, "itemCode"],
]);
let timer: any = null;
const SubjectNavigation: FC<any> = ({ history, location, setFrom }) => {
  const subjectId = new URLSearchParams(location.search).get("subjectId");
  const [searchKeyWordType, setSearchKeyWordType] = useState(11);
  const [count, setCount] = useState(0);
  const onChange = (pageNumber: any) => {
    let newPage = { ...page, currentPage: pageNumber };
    setPage(newPage);
    setCount(count + 1);
  };
  //
  // 学科列表
  const [oneSubjectList, setOneSubjectList] = useState([]);
  // 学科二级列表
  const [secondSubList, setSecondSubList] = useState([]);
  // 学科三级列表
  const [treeSubList, setTreeSubList] = useState([]);
  // 搜索关键词列表
  const [searchKeyWorkList, setSearchKeyWorkList] = useState([]);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  // 级别列表
  const levelList = [
    {
      title: "全部",
      key: "",
    },
    {
      title: "国家级",
      key: 1,
    },
    {
      title: "省级",
      key: 2,
    },
    {
      title: "市级",
      key: 3,
    },
  ];
  const sortList = [
    {
      title: "全部",
      key: "",
    },
    {
      title: "最近更新",
      key: 1,
    },
    {
      title: "学习最多",
      key: 2,
    },
    {
      title: "学分最多",
      key: 3,
    },
  ];
  const getSubjectList = async () => {
    const { code, data, msg }: any = await axios.post(
      "/shop/front/ce/subject/list",
      {}
    );
    if (code === 0) {
      // 设置一级菜单栏
      setOneSubjectList(data);
      // 设置二级菜单栏
      setSecondSubList(data[0].children);
      // 设置三级菜单
      setTreeSubList(data[0].children[0].children);
      // 设置二级菜单默认的Key
      // setSelectedSecondKey(data[0].children[0].key);
      // 设置三级菜单默认的key
      // setSelectedTreeKey(data[0].children[0].children[0].key);
    } else {
      message.error(msg);
    }
  };
  // 选中学科
  const [selectData, setSelectData] = useState({
    oneKey: "",
    twoKey: "",
    threeKey: "",
  });

  //级别列表选中项
  const [selectLevelKey, setSelectLevelKey] = useState("");
  //排序列表选中项
  const [selectSortKey, setSelectSortKey] = useState("");

  // 课程列表
  const [courseList, setCourseList] = useState([]);
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 8,
    totalResultSize: 0,
  });
  const getCourseList = async () => {
    const body: any = {
      item: {
        [`${keyWordMap.get(searchKeyWordType)}`]: searchKeyWord,
      },
      page: {
        currentPage: page.currentPage,
        pageSize: page.pageSize,
      },
    };
    const { oneKey, twoKey, threeKey } = selectData;
    if (threeKey || twoKey || oneKey) {
      body.item.subjectId = threeKey || twoKey || oneKey;
    }
    if (selectLevelKey) {
      body.item.itemLevel = selectLevelKey;
    }
    if (selectSortKey) {
      body.item.itemOrderByType = selectSortKey;
    }
    const { code, data, msg }: any = await axios.post(
      "/shop/front/ce/item/list",
      body
    );
    if (code === 0) {
      const { currentPage, totalResultSize } = data.page;
      const { pageSize } = page;
      setCourseList(data.itemList);
      setPage({ currentPage, pageSize, totalResultSize });
    } else {
      message.error(msg);
    }
  };

  useEffect(() => {
    getSubjectList();
  }, []);

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(() => {
      getCourseList();
    }, 600);
  }, [selectData, count, selectLevelKey, selectSortKey]);

  const jump = (data: any) => {
    setFrom({ from: { path: "/index/subjectNavigation", name: "学科导航" } });
    history.push({ pathname: `/index/subject/${data.id}` });
  };
  /**
   * 得到搜索关键词列表
   */
  const getSearhKeyWorkList = async () => {
    const { data = [] }: any = await axios.post(
      `/shop/front/ce/getItemSearchKeywordList/${searchKeyWordType}`,
      {}
    );
    setSearchKeyWorkList(data.slice(0, 10));
  };
  /**
   * 根据类型不同保存搜索关键词
   */
  const saveSearchKeyWordByType = async () => {
    const { code, data, msg }: any = await axios.post(
      `/shop/front/ce/saveItemSearchKeywordRecord`,
      {
        keyword: searchKeyWord,
        searchType: searchKeyWordType,
      }
    );
    getCourseList();
    setSearchKeyWorkList([]);
  };
  /**
   * 清除用户搜索记录
   */
  const clearSearchKeyWordHistory = async () => {
    const { msg } = await axios.post(
      `/shop/front/ce/clearUserItemSearchKeyword`,
      {}
    );
    message.success(msg);
  };
  return (
    <div className={"subject-navigation"}>
      <div className="nav-container">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/index/home">首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>学科导航</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className={"subject-classify"}>
        <div className="search-box">
          <p>
            <Select
              options={[
                {
                  value: 11,
                  label: "项目名称",
                },
                {
                  value: 12,
                  label: "项目负责人",
                },
                {
                  value: 13,
                  label: "项目编号",
                },
              ]}
              size="large"
              defaultValue={searchKeyWordType}
              style={{
                width: "160px",
              }}
              onChange={(value) => {
                setSearchKeyWordType(value);
              }}
            ></Select>
          </p>
          <p
            style={{
              position: "relative",
            }}
          >
            <Input
              size="large"
              allowClear={true}
              style={{
                width: "400px",
              }}
              onChange={(e) => {
                setSearchKeyWord(e.target.value);
              }}
              onFocus={() => {
                getSearhKeyWorkList();
              }}
              value={searchKeyWord}
            />
            {searchKeyWorkList.length > 0 && (
              <div className="searchHistory-box">
                {searchKeyWorkList.map((item: any) => (
                  <p
                    onClick={() => {
                      setSearchKeyWord(item.keyword);
                    }}
                  >
                    {item.keyword}
                  </p>
                ))}
                <p
                  style={{
                    textAlign: "center",
                  }}
                >
                  <a
                    onClick={(e) => {
                      clearSearchKeyWordHistory();
                    }}
                  >
                    清除记录
                  </a>
                </p>
              </div>
            )}
          </p>
          <Button size="large" type="primary" onClick={saveSearchKeyWordByType}>
            搜索
          </Button>
        </div>
        <div className={"classify-row"}>
          <span className={"title"}>学科</span>
          <ul className={"items"}>
            <li
              key={""}
              className={selectData.oneKey === "" ? "selected" : ""}
              onClick={() => {
                const newData = { ...selectData };
                newData.oneKey = "";
                newData.twoKey = "";
                setSelectData(newData);
              }}
            >
              全部
            </li>
            {oneSubjectList.map((subject: any, i) => (
              <li
                key={i}
                className={selectData.oneKey === subject.key ? "selected" : ""}
                onClick={() => {
                  const newData = { ...selectData };
                  newData.oneKey = subject.key;
                  newData.twoKey = "";
                  setSecondSubList(subject.children || []);
                  setSelectData(newData);
                  setTreeSubList([]);
                }}
              >
                {subject.title}
              </li>
            ))}
          </ul>
        </div>
        {selectData.oneKey && (
          <div className={"classify-row"}>
            <span className={"title"}></span>
            <ul className={"items subborder"}>
              <li
                className={selectData.twoKey === "" ? "selected" : ""}
                onClick={() => {
                  const newData = { ...selectData };
                  newData.twoKey = "";
                  newData.threeKey = "";
                  setSelectData(newData);
                  setTreeSubList([]);
                }}
              >
                全部
              </li>
              {secondSubList.map((sub: any, i) => (
                <li
                  key={i}
                  className={selectData.twoKey === sub.key ? "selected" : ""}
                  onClick={() => {
                    const newData = { ...selectData };
                    newData.twoKey = sub.key;
                    newData.threeKey = "";
                    setSelectData(newData);
                    setTreeSubList(sub.children || []);
                  }}
                >
                  {sub.title}
                </li>
              ))}
            </ul>
          </div>
        )}
        {selectData.twoKey && treeSubList.length > 0 && (
          <div className={"classify-row"}>
            <span className={"title"}></span>
            <ul className={"items subborder"}>
              <li
                key={""}
                className={selectData.threeKey === "" ? "selected" : ""}
                onClick={() => {
                  const newData = { ...selectData };
                  newData.threeKey = "";
                  setSelectData(newData);
                }}
              >
                全部
              </li>
              {treeSubList.map((sub: any, i) => (
                <li
                  key={i}
                  className={selectData.threeKey === sub.key ? "selected" : ""}
                  onClick={() => {
                    const newData = { ...selectData };
                    newData.threeKey = sub.key;
                    setSelectData(newData);
                  }}
                >
                  {sub.title}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <div className={"level-classify"}>
        <div className={"classify-row"}>
          <span className={"title"}>级别</span>
          <ul className={"items"}>
            {levelList.map((sub: any, i) => (
              <li
                key={i}
                className={selectLevelKey == sub.key ? "selected" : ""}
                onClick={() => {
                  setSelectLevelKey(sub.key);
                }}
              >
                {sub.title}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={"level-classify"}>
        <div className={"classify-row"}>
          <span className={"title"}>排序</span>
          <ul className={"items"}>
            {sortList.map((sub: any, i) => (
              <li
                key={i}
                className={selectSortKey == sub.key ? "selected" : ""}
                onClick={() => {
                  setSelectSortKey(sub.key);
                }}
              >
                {sub.title}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className={"content-course"}>
        <div className={"content-course-box"}>
          <div className={"content-course-res"}>
            <span>共{page.totalResultSize}个结果</span>
          </div>
          <div className={"content-course-list"}>
            {courseList.map((course: any, i) => (
              <div
                key={i}
                className={"content-course-item"}
                onClick={() => {
                  jump(course);
                }}
              >
                <div className={"item-img"}>
                  <img src={course.imageAllPath} alt="" />
                </div>
                <div className={"item-text"}>
                  <div className={"p-box"}>
                    <p>项目负责人：{course.itemLeaderName}</p>
                    <p>学分：{course.creditInfo}</p>
                    <p>编号：{course.itemCode}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={"subject-pagination"}>
          {courseList.length ? (
            <Pagination
              showSizeChanger={false}
              showQuickJumper
              current={page.currentPage}
              pageSize={page.pageSize}
              total={page.totalResultSize}
              onChange={onChange}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(SubjectNavigation);
